import axios from 'axios'
import resetMessage from '@/components/baseComponent/message.js'
// import { Message } from 'view-ui-plus'
// import appStore from '@/store'
// import { wordCaseUp } from './tool.js'
import qs from 'qs'
// 创建axios实例对象
const $api = axios.create({
  baseURL: import.meta.env.APP_FLAG === 'dev' ? '/api' : import.meta.env.APP_FLAG === 'staging' ? '' : 'https://erp.sunsky-online.com',
  timeout: 30000
})

// 请求拦截器
$api.interceptors.request.use(
  async (config) => {
    config.headers['X-Requested-With'] = `XMLHttpRequest`
    if (import.meta.env.APP_FLAG == 'dev') {
      try {
        const { canary } = await import('../../canary.js')
        if (canary) {
          config.headers['x-canary'] = canary
        }
      } catch (e) {}
    }
    if (config.method === 'get' && config.params) {
      // 对查询参数进行 URL 编码
      const encodedParams = new URLSearchParams(config.params)
      // 将编码后的查询参数赋值给原先的params
      config.params = encodedParams
    } else if (config.method === 'post' && config.headers['X-Custom-Header']) {
      config.data = qs.stringify(config.data, { arrayFormat: 'brackets' })
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
$api.interceptors.response.use(
  (response) => {
    const res = response.data || response
    return res
  },
  (error) => {
    const { response } = error
    const { status, config } = response
    if (status === 404) {
      const { statusText } = response
      resetMessage({ type: 'error', message: statusText, duration: 3 })
    } else if (status === 417 || status === 401 || status === 412) {
      const {
        data: { message, code }
      } = response
      let show = true
      if (config && config.url) {
        if (config.url.indexOf('/publish/product') != -1) {
          show = false
        }
      }
      // const { changeShowTask } = appStore.useTaskShow
      // changeShowTask(true)
      // if (config.url.indexOf('/upload/single') != -1) {
      //   Message.error({
      //     render: (h) => {
      //       return h('a', {href: 'https://erp.'}, {
      //         default: ()=> message
      //       })
      //     }
      //   })
      // } else {
      show && resetMessage({ type: 'error', message, duration: 5, closable: true })
      // }
    } else {
      resetMessage({ type: 'error', message: 'Server Exception！', duration: 5, closable: true })
    }
    return Promise.reject(error)
  }
)

// 导出axios实例
export default $api
